import { Button, cn, NotificationBadge, Typography } from "@riac/design-system";
import React from "react";

type HeaderIconButtonProps = {
  IconComponent: React.ElementType;
  label: string;
  notificationCount?: number;
  className?: string;
  children?: React.ReactNode;
  hideLabel?: boolean,
} & ({
  to: string;
} | ({
  onPress: () => void;
}))

export const HeaderIconButton: React.FC<HeaderIconButtonProps> = (props) => {
  const { IconComponent, label, notificationCount = 0, className, hideLabel, children, ...buttonProps } = props;

  return (
    <Button
      unstyled
      {...buttonProps}
      className={cn('p-2 rounded-full hover:bg-neutral-200 active:bg-neutral-300 text-text-light size-10 relative group', className)}
      aria-label={hideLabel ? label : undefined}
    >
      <IconComponent className={'size-6'} />

      {notificationCount > 0 && (
        <NotificationBadge className={'absolute right-1.5 top-2'} whiteBorder />
      )}

      {!hideLabel &&
        <Typography size='xs' weight='bold' className={'pointer-events-none absolute bottom-1 left-1/2 -translate-x-1/2 w-max translate-y-full opacity-0 group-hover:opacity-100 transition-all'}>
          {label}
        </Typography>
      }
      {children}
    </Button>
  );
};